export const regexPatterns: Record<string, RegExp> = {
  separatorDash: /\s-\s|\s-|-\s/,
}

export const ACTIVATION_EMAIL_HASH_PATTERN = /^[a-zA-Z0-9\-_]{16,128}$/

export const JWT_PATTERN = /^[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+$/

// Customer / contact form field validation patterns (theme-agnostic).
export const firstNameValidationPattern = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-ž\s'-]+$/
export const lastNameValidationPattern = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-ž\s'-]+$/
export const emailValidationPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const phoneValidationPattern = /^\d{6,15}$/
export const legalNameValidationPattern = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-ž0-9\s&.,'"()-]{1,160}$/
export const zipValidationPattern = /^[A-Za-z0-9\s-]{1,32}$/
export const registrationCodeValidationPattern = /^[A-Za-z0-9\s-]{1,50}$/
export const addressValidationPattern = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-ž0-9\s.,/'()-]{1,200}$/
export const intlCodeValidationPattern = /^\+\d{1,4}$/
export const cityValidationPattern = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-ž0-9\s.,'-]{1,100}$/
